<template>
  <v-col cols="12" lg="11" xl="9" class="pa-0 room-card my-8">
    <div class="room-bg room-bg-top-left" :style="{backgroundImage: `url(${optimizedImageURL(roomInfo.topLeftBackgroundImage)}`}" />
    <div class="room-bg room-bg-bottom-right" :style="{backgroundImage: `url(${optimizedImageURL(roomInfo.bottomRightBackgroundImage)}`}" />
    <div
      class="text-h3 text-md-h2 text-center text-uppercase"
      :class="{'mb-8': !roomInfo.subtitle, 'mb.3': roomInfo.subtitle}"
    >
      {{roomInfo.title}}
    </div>
    <MarkdownBlock v-if="roomInfo.subtitle" class="subtitle text-center" tag="p" :inline="true" :text="roomInfo.subtitle" />
    <ContainerRatio
      :ratio="roomInfo.chatEmbedURL && roomInfo.chatEnabled && $vuetify.breakpoint.smAndDown ? 0.9 : 16/11"
    >
      <v-card light :style="cardStyle" style="overflow: hidden;" class="d-flex">
        <v-row no-gutters class="shrink">
          <transition mode="out-in">
            <seo-v-img
              :src="optimizedImageURL(roomInfo.streamingPlaceholder)"
              :lazy-src="getMetaData(roomInfo.streamingPlaceholder)['image-lazy-src']"
              :aspect-ratio="16/9"
              cover
              width="100%"
              style="overflow: visible;
                    cursor: pointer;"
              v-if="!playing"
              @click.native="requestPlay"
            >
            </seo-v-img>
            <v-responsive :aspect-ratio="roomInfo.chatEmbedURL && roomInfo.chatEnabled && $vuetify.breakpoint.smAndDown ? 0.9 : 16/9" v-else>
              <v-row class="fill-height" no-gutters>
                <v-col cols="12" :md="roomInfo.chatEmbedURL && roomInfo.chatEnabled ? 9 : 12">
                  <iframe :src="roomInfo.streamingEmbedURL"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen width="100%" height="100%" />
                </v-col>
                <v-col cols="12" md="3" v-if="roomInfo.chatEmbedURL && roomInfo.chatEnabled">
                  <iframe :src="roomInfo.chatEmbedURL" width="100%" height="100%" frameborder="0"></iframe>
                </v-col>
              </v-row>
            </v-responsive>
          </transition>
        </v-row>
      </v-card>
    </ContainerRatio>
  </v-col>
</template>
<script>
import GetRoom from '@/graphql/GetRoom.gql'
// import Logo from '@/assets/img/logo.svg'
import { optimizedImageURL, getMetaData, getAspectRatio } from '@/services/OptimizedImage'
// import { filter } from 'lodash'
// import CalendarIcon from '@/assets/img/google-calendar-icon.svg'
import getVideoId from 'get-video-id'
import ContainerRatio from '@/atoms/ContainerRatio'
import { MarkdownBlock } from '@monogrid/vue-lib'

export default {
  name: 'RoomCard',
  components: {
    ContainerRatio,
    MarkdownBlock
    // Logo
    // CalendarIcon
  },
  props: {
    room: {
      type: Object,
      required: true
    },
    playing: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    // nextTalk () {
    //   return filter(
    //     this.talksInThisRoom.concat().sort((a, b) => {
    //       return this.distanceInTheFuture(a) > this.distanceInTheFuture(b) ? 1 : -1
    //     }),
    //     (t) => this.distanceInTheFuture(t) > 0
    //   )[0]
    // },
    // talksInThisRoom () {
    //   if (this.Talks) {
    //     return this.Talks._referents.TalkReferents.items
    //   }
    //   return []
    // },
    // currentlyLiveTalk () {
    //   for (let i = 0; i < this.talksInThisRoom.length; i++) {
    //     if (this.isTalkCurrentlyLive(this.talksInThisRoom[i])) {
    //       return this.talksInThisRoom[i]
    //     }
    //   }
    //   return false
    // },
    videoID () {
      return getVideoId(this.room.streamingEmbedURL)
    },
    cardStyle () {
      return {
        // height: '100%',
        flexDirection: 'column',
        backgroundColor: this.room.primaryBackgroundColor,
        boxShadow: `6px 6px 0 3px ${this.room.secondaryBackgroundColor} !important`
      }
    },
    roomInfo () {
      return this.Room || this.room
    }
  },
  apollo: {
    Room: {
      query: GetRoom,
      pollInterval: 1000,
      skip () {
        return !this.playing
      },
      variables () {
        return {
          status: 'PUBLISHED',
          id: this.room.id
        }
      }
    }
  },
  methods: {
    optimizedImageURL,
    getMetaData,
    getAspectRatio,
    requestPlay () {
      this.$emit('playing', this.room.id)
    }
    // calendarAddLink (talk) {
    //   const sd = new Date(talk.startingAt).toISOString().replace(/(-|:|\.000Z)/g, '')
    //   const ed = new Date(talk.endingAt).toISOString().replace(/(-|:|\.000Z)/g, '')
    //   return `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(talk.title)}&dates=${sd}/${ed}&ctz=Etc/GMT&details=${encodeURIComponent(talk.aboutDescription)}`
    // },
    // distanceInTheFuture (talk) {
    //   const now = this.$root.getNow().getTime()
    //   const start = new Date(talk.startingAt).getTime()
    //   return start - now
    // },
    // isTalkCurrentlyLive (talk) {
    //   const now = this.$root.getNow().getTime()
    //   const start = new Date(talk.startingAt).getTime()
    //   const end = new Date(talk.endingAt).getTime()
    //   return now >= start && now < end
    // }
  }
}
</script>

<style lang="scss" scoped>
.logo ::v-deep {
  width: 50px;
  height: 50px;

  path {
    fill: inherit !important;
  }
}

.v-card {
  z-index: $z-content-prominent;
}

.room-bg {
  position: absolute;
  width: 50%;
  padding-top: 50%;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  &-top-left {
    top: -10%;
    left: -30%;
  }

  &-bottom-right {
    bottom: -20%;
    right: -30%;
  }
}

.room-card {
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
}

.calendar-icon {
  width: 30px;
  height: 30px;
}

.subtitle {

  font-size: 1.2em;

  strong {
    font-size: 1.4em;
  }
}
</style>
